export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "close-notification": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fermer la notification"])}
      },
      "en": {
        "close-notification": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Close the notification"])}
      }
    }
  })
}
